import { Icon, type IconType } from "@sellar-io/components";
import type { ReactNode } from "react";
import { Link } from "react-router";
import { useMediaQuery } from "usehooks-ts";
import { NavigationOverlay } from "./NavigationOverlay";

export const NavigationActivityOverlay = ({
  id,
  title,
  icon,
  href,
  hasUnread,
  children,
}: {
  id: string;
  title: string;
  icon: IconType;
  href: string;
  hasUnread: boolean;
  children: ReactNode;
}) => {
  const isMobile = useMediaQuery("(max-width: 640px)");
  const label = hasUnread ? `${title}, unread activity` : title;
  const className =
    "relative inline-flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-full p-0 text-zinc-800 hover:text-[#a34fd2] focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-purple-600 aria-expanded:text-[#8c23c7]";
  const content = (
    <>
      <Icon icon={icon} size="20px" />
      {hasUnread && (
        <span
          aria-hidden="true"
          className="absolute top-0.5 right-0.5 size-1.5 rounded-full bg-[#a34fd2]"
        />
      )}
    </>
  );
  if (isMobile) {
    return (
      <Link to={href} aria-label={label} className={className}>
        {content}
      </Link>
    );
  }
  return (
    <NavigationOverlay
      id={id}
      title={title}
      trigger={(props) => (
        <button
          {...props}
          type="button"
          aria-label={label}
          className={className}
        >
          {content}
        </button>
      )}
    >
      {children}
    </NavigationOverlay>
  );
};
